export interface BrandSwatch {
  label: string;
  value: string;
}

export const BRAND_SWATCHES: BrandSwatch[] = [
  { label: 'Navy', value: '#1E40AF' },
  { label: 'Forest', value: '#166534' },
  { label: 'Indigo', value: '#4338CA' },
  { label: 'Teal', value: '#0F766E' },
  { label: 'Charcoal', value: '#374151' },
  { label: 'Crimson', value: '#9F1239' },
  { label: 'Violet', value: '#7E22CE' },
  { label: 'Cobalt', value: '#0369A1' },
  { label: 'Sage', value: '#15803D' },
  { label: 'Slate', value: '#475569' },
  { label: 'Amber', value: '#92400E' },
  { label: 'Sienna', value: '#78350F' },
];
